module.exports = __webpack_public_path__ + "img/footer_bg.dc95f65d.jpg";